var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "q-body-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-grey-10 no-underline",
                  attrs: {
                    to: {
                      name: "expenses-dashboard",
                      params: { teamId: _vm.activeTeam.id }
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tc("expense", 2)) + "\n      "
                  )
                ]
              ),
              _vm._v(" / "),
              _c("span", { staticClass: "text-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("capture_expense")))
              ])
            ],
            1
          ),
          !_vm.allCaptured
            ? _c(
                "div",
                [
                  _c("q-btn", {
                    staticClass: "q-mr-sm",
                    attrs: {
                      disabled: !_vm.hasPrevious,
                      icon: "navigate_before",
                      flat: "",
                      dense: ""
                    },
                    on: { click: _vm.handlePrevious }
                  }),
                  _c("q-btn", {
                    staticClass: "q-mr-lg",
                    attrs: {
                      disabled: !_vm.hasNext,
                      icon: "navigate_next",
                      flat: "",
                      dense: ""
                    },
                    on: { click: _vm.handleNext }
                  }),
                  _c(
                    "q-btn",
                    {
                      staticClass: "q-mr-md",
                      attrs: { color: "primary", flat: "", icon: "delete" },
                      on: { click: _vm.handleDelete }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("delete")) + "\n      "
                      )
                    ]
                  ),
                  _c(
                    "q-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.$t("save")) + "\n      ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "layout-padding",
          staticStyle: { "min-height": "calc(100vh - 60px - 70px)" }
        },
        [
          !_vm.allCaptured
            ? _c("div", { staticClass: "row full-height" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _vm.document
                      ? _c("document-viewer", {
                          attrs: {
                            document: _vm.document,
                            showDownloadButton: true
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("expense-form", {
                      model: {
                        value: _vm.formData,
                        callback: function($$v) {
                          _vm.formData = $$v
                        },
                        expression: "formData"
                      }
                    })
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "flex column text-center" }, [
                _c("img", {
                  attrs: { src: require("assets/emptystates/items_empty.svg") }
                }),
                _c("h6", { staticClass: "q-my-md text-faded" }, [
                  _vm._v(_vm._s(_vm.$t("no_expenses_to_capture")))
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "q-btn",
                      {
                        directives: [{ name: "is-user", rawName: "v-is-user" }],
                        staticClass: "q-mt-lg",
                        attrs: { color: "primary", outline: "" },
                        on: {
                          click: function($event) {
                            _vm.$router.push({ name: "expenses-dashboard" })
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("back_to_expense_dashboard")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }